// extracted by mini-css-extract-plugin
export default {"AggregateLabels":"single-select-group-header-label-module__AggregateLabels--IsEMA","SanitizedHtml":"single-select-group-header-label-module__SanitizedHtml--YFlXN"};